import { useAppSelector } from "../redux"

export const useProductName = () => {
  const product = useAppSelector(state => state.product.product_no_design.data)
  return product.title || product.name
}